var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSh = function SvgSh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M11.968 12H12v-.032l-.032.032ZM12 6.261V.001h-.002C5.371 0 0 5.373 0 12h6.26V8.474l3.526 3.526h2.182l.032-.033V9.787L8.474 6.261H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M6.071 1.565a12.057 12.057 0 0 0-4.506 4.506v5.93h3.13V4.695H12v-3.13H6.071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 10.524 7.738 6.261H6.262L12 12v-1.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BCA76B",
    d: "M13.565 8v5.74c0 2.795 3.653 3.651 3.653 3.651s3.652-.856 3.652-3.652V8s-1.37-1-3.652-1c-2.283 0-3.653 1-3.653 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#128BBF",
    d: "M13.565 13.739c0 2.795 3.653 3.652 3.653 3.652s3.652-.857 3.652-3.652V10.7h-7.3l-.005 3.039Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSh;